import { UtilService } from '@app/utility/util.service';
var ThaiDatePipe = /** @class */ (function () {
    function ThaiDatePipe(util) {
        this.util = util;
    }
    ThaiDatePipe.prototype.transform = function (date, format) {
        return this.util.transformDate(date, format);
    };
    return ThaiDatePipe;
}());
export { ThaiDatePipe };



// WEBPACK FOOTER //
// ./src/app/shared/thaidate.pipe.ts.pre-build-optimizer.js